export default "__VITE_ASSET__CApp61ij__"